import { useTranslation } from "react-i18next";
import { Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const MenuItemLink = ({ label, link, ...rest }) => {
  const { t } = useTranslation();

  return (
    <Button href={link} target="_blank" {...rest}>
      {t(label)}
    </Button>
  );
};

export const MenuItemPopupHandler = ({
  label,
  setOpenPopup,
  messageCount,
  sx,
  ...rest
}) => {
  const { t } = useTranslation();

  const handleOnClick = () => setOpenPopup(true);

  return (
    <>
      <Button
        className={messageCount != 0 && "message-header"}
        onClick={handleOnClick}
        {...rest}
        sx={sx}
      >
        {t(label)}
      </Button>
    </>
  );
};
export const MenuItemLinkInside = ({ label, link, ...rest }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Button onClick={() => navigate(link)} {...rest}>
      {t(label)}
    </Button>
  );
};
export const MenuItemChildren = ({ label, links, ...rest }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenuItemClick = (path) => {
    navigate(path);
    handleClose();
  };
  return (
    <>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {links?.length > 0 &&
          links?.map(({ link, name }) => (
            <MenuItem onClick={() => handleMenuItemClick(link)}>
              {t(name)}
            </MenuItem>
          ))}
      </Menu>
      <Button onClick={handleClick} {...rest}>
        {t(label)}
      </Button>
    </>
  );
};
